import React from "react";
import { BOT_CHANNEL } from "../../../../contexts/bots/BotsContext";
import { useTranslation } from "../../../../hooks/useLocalization";
import { WebIcon } from "../bodies/Web";
import ChannelCard from "./ChannelCard";

const ChannelWebCard = (props) => {
  const { t } = useTranslation();
  const { channelName, handlers } = props;
  return (
    <ChannelCard
      {...props}
      name={t(BOT_CHANNEL.title(channelName))}
      icon={WebIcon}
      handlers={handlers}
    />
  );
};

export default ChannelWebCard;
